<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">菜单修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="list" :rules="rules" ref="addForm" label-width="80px">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="名称" required prop="name">
                                    <el-input v-model="list.name"></el-input>
                                </el-form-item>
                            </el-col>
                          <el-col :span="12" class="item">
                            <el-form-item label="排序" required prop="sort">
                              <el-input v-model="list.sort"></el-input>
                            </el-form-item>
                          </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="图标" required prop="icon">
                                    <el-input v-model="list.icon"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="路由" required prop="url">
                                    <el-input v-model="list.url"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Edit',
        props: ["listMenuDTO"],
        data() {
            return {

                loading: false,

                addForm: {
                    timeStr: timeStr,
                    sign: '',
                    staffCode: getStaffCode(),
                    listMenu: [],
                },
                list: {
                    menuCode: '',
                    name: '',
                    url: '',
                    icon: '',
                  sort:'',
                    listMenu: [],
                },
                rules: {
                    name: [
                        {required: true, message: '请输入菜单名称', trigger: 'blur'},
                    ],
                    url: [
                        {required: true, message: '请输入路由', trigger: 'blur'},
                    ],
                  sort:[
                    { required: true, message: '请输入排序', trigger: 'blur' },
                  ],
                    icon: [
                        {required: true, message: '请输入图标', trigger: 'blur'},
                    ],
                }

            }
        },

        methods: {

            init(data) {

                this.list = {
                    menuCode: data.menuCode,
                    name: data.name,
                    url: data.url,
                    icon: data.icon,
                    sort: data.sort,
                    listMenu: data.children,
                }

                let aa = JSON.stringify(this.listMenuDTO);
                aa = aa.replace(/children/g, "listMenu");
                this.addForm.listMenu = JSON.parse(aa);
            },

            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(addForm) {
                this.$refs[addForm].validate((valid) => {
                    if (valid) {
                        console.log(this.addForm.listMenu);
                        for (let i in this.addForm.listMenu) {
                            console.log(this.addForm.listMenu[i]);
                            if (this.addForm.listMenu[i].menuCode == this.list.menuCode) {
                                console.log("11")
                                console.log(this.addForm.listMenu[i]);
                                this.addForm.listMenu[i].name = this.list.name;
                                this.addForm.listMenu[i].sort = this.list.sort;
                                this.addForm.listMenu[i].url = this.list.url;
                                this.addForm.listMenu[i].icon = this.list.icon;
                                this.addSubmit();
                                return;
                            } else {
                                //2级循环
                                for (let j in this.addForm.listMenu[i].listMenu) {
                                    console.log(this.addForm.listMenu[i].listMenu[j]);
                                    if (this.addForm.listMenu[i].listMenu[j].menuCode == this.list.menuCode) {
                                        console.log("22")
                                        console.log(this.addForm.listMenu[i].listMenu[j]);
                                        if (!this.addForm.listMenu[i].listMenu[j].listMenu) {
                                            this.$set(this.addForm.listMenu[i].listMenu[j], "listMenu", []);
                                        }
                                        this.addForm.listMenu[i].listMenu[j].name=this.list.name;
                                        this.addForm.listMenu[i].listMenu[j].sort=this.list.sort;
                                        this.addForm.listMenu[i].listMenu[j].url=this.list.url;
                                        this.addForm.listMenu[i].listMenu[j].icon=this.list.icon;
                                        this.addSubmit();
                                        return;
                                    } else {
                                        //3级循环
                                        if (this.addForm.listMenu[i].listMenu != undefined) {
                                            for (let k in this.addForm.listMenu[i].listMenu[j].listMenu) {
                                                console.log(this.addForm.listMenu[i].listMenu[j].listMenu[k])
                                                if (this.addForm.listMenu[i].listMenu[j].listMenu[k].menuCode == this.list.menuCode) {
                                                    console.log("33")
                                                    console.log(this.addForm.listMenu[i].listMenu[j].listMenu[k])
                                                    this.addForm.listMenu[i].listMenu[j].listMenu[k].name = this.list.name;
                                                    this.addForm.listMenu[i].listMenu[j].listMenu[k].sort = this.list.sort;
                                                    this.addForm.listMenu[i].listMenu[j].listMenu[k].url = this.list.url;
                                                    this.addForm.listMenu[i].listMenu[j].listMenu[k].icon = this.list.icon;
                                                    this.addSubmit();
                                                    return;
                                                }
                                            }
                                        }
                                    }

                                }
                            }
                        }

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });


            },

            addSubmit() {

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl + "Menu/Edit",
                    data: this.addForm
                }).then(
                    (response) => {
                        console.log(JSON.stringify(response));
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("menuShow");
                        }else{
                            this.$message({type:"info",message:"编辑失败"});
                        }
                    }
                )
            },


        }
    }


</script>


<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x: auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }

            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y: scroll;
                height: auto;
            }

            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left: 16px;
        width: 56px;
        height: 36px;
        border: none;
        cursor: pointer;
    }

    .btn-close {
        color: #313131;
        background-color: transparent;
    }


    .row {
        padding: 10px 0px;
    }

    .item {
        padding: 0px 20px;
    }

    .label {
        padding: 5px 0px;
    }


</style>
